import React from "react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { NodeProps, Node } from "@xyflow/react";

type InErrorModeNode = Node<InterfaceToRecord<ExtraNodeData>>;

export default function InErrorMode(props: NodeProps<InErrorModeNode>): JSX.Element {
    return <ActionConfigNode nodeKind={props.type} {...props.data} />;
}
